export var EcommItemType = /*#__PURE__*/function (EcommItemType) {
  EcommItemType["PRODUCT"] = "product";
  EcommItemType["EVENT"] = "event";
  return EcommItemType;
}({});